import { ButtonBase, CircularProgress, Tooltip } from '@mui/material'
import type React from 'react'
import { AttendanceStatusChip } from 'Pages/Attendance/AttendanceStatusChip'
import { type AttendanceCellDto } from 'Pages/Attendance/types'

export function AttendanceStatusButton (props: {
  cell: AttendanceCellDto
  disabled: boolean
  fullWidth?: boolean
  ariaLabel?: string
  saving: boolean
  tooltipTitle?: string
  onClick: (event: React.MouseEvent<HTMLElement>) => void
}): JSX.Element {
  const status = props.cell.status ?? 'Empty'
  const inactive = props.disabled && props.cell.status != null
  const ariaLabel = props.ariaLabel ?? (props.cell.status == null ? 'Enter attendance status' : `Attendance status ${props.cell.status}`)
  const button = (
    <ButtonBase
      aria-label={ariaLabel}
      data-testid="attendance-status-button"
      disabled={props.disabled}
      onClick={props.onClick}
      sx={{
        borderRadius: '999px',
        cursor: props.disabled ? 'default' : 'pointer',
        fontFamily: 'Quicksand, sans-serif',
        justifyContent: 'flex-start',
        minHeight: 32,
        minWidth: props.fullWidth === true ? 0 : 128,
        width: props.fullWidth === true ? '100%' : 'auto',
        '&:focus-visible': {
          outline: theme => `2px solid ${theme.palette.primary.main}`,
          outlineOffset: '2px'
        }
      }}
    >
      {props.saving
        ? <CircularProgress size={18} />
        : <AttendanceStatusChip status={status} disabled={props.disabled} fullWidth={props.fullWidth} inactive={inactive} />}
    </ButtonBase>
  )

  return (
    <Tooltip title={props.tooltipTitle ?? ''}>
      <span data-testid="attendance-status-tooltip-target" style={{ display: props.fullWidth === true ? 'block' : 'inline-block', width: props.fullWidth === true ? '100%' : undefined }}>
        {button}
      </span>
    </Tooltip>
  )
}
